const FETCH_EMAILS_LOG = 'fetch_emails-log';
const EMAIL_LOG_RESEND = 'resend_email-log';

export default {
    FETCH_EMAILS_LOG,
    EMAIL_LOG_RESEND,
};
